(function () {    
    angular.module('bizPartEngage').directive('bizOneGoal', bizOneGoalDirective);    
    
    bizOneGoalDirective.$inject = ["bizCore"];

    function bizOneGoalDirective(bizCoreProvider) {
        var directive = {
            restrict: 'E',
            scope: {
                goalId: '=',
                isRoot: '=?'
            },
            templateUrl: bizCoreProvider.getView('bizOneGoalDirective', 'FrontEnd/Modules/EngagementGoals/Views/Directives/oneGoal.html'),
            bindToController: true,
            controller: bizOneGoalController,
            controllerAs: 'vm',
        };

        bizOneGoalController.$inject = ["modules.goals.service", "$mdDialog", "$scope", "$mdToast", "$timeout", "bizValidationService", "$state", "$q", "$rootScope", "$filter", "bizMediabankService"];

        function bizOneGoalController(engagementGoalsService, $mdDialog, $scope, $mdToast, $timeout, bizValidationService, $state, $q, $rootScope, $filter, bizMediabankService) {
            var vm = this;

            vm.DefaultNewProgressSteps = 5;
            vm.NewProgressSteps = 5;

            vm.EditDate = moment();

            vm.deleteMode = true;
            vm.UploadSettings = {
                FileType: bizMediabankService.FileTypes.Image,
                FileLocation: bizMediabankService.UploadLocations.Goal,
                FilePattern: '',
                IsPrivate: true,
                IsInvisible: false,
                IsPrivateControlHidden: true,
                IsInvisibleControlHidden: true,
                IsUser: true
            };

            vm.labels = ["Utfall", "Återstående"];
            vm.colors = ["#0079EA", "#65AEF2"];
            vm.options = { cutoutPercentage: 75, title: {
                display: false,
                text: 'Utfallsrapportering'
            } };
            vm.data = [0, 100];
            
            vm.SelectedPeriod = engagementGoalsService.GetSelectedPeriod();
            vm.Date = BizPartCoreHelpers.getDateNow();
            vm.Years = [
                {
                    Name: moment(vm.Date).year() + '',
                    Id: moment(vm.Date).year(),
                    StartDate: moment(vm.Date).startOf('year'),
                    EndDate: moment(vm.Date).endOf('year')
                },
                {
                    Name: moment(vm.Date).add(1, 'years').year() + '',
                    Id: moment(vm.Date).add(1, 'years').year(),
                    StartDate: moment(vm.Date).add(1, 'years').startOf('year'),
                    EndDate: moment(vm.Date).add(1, 'years').endOf('year')
                }
            ];            

            vm.SelectedYear = vm.Years[0];            

            vm.goalTypesLoadedDefer = $q.defer();
            vm.goalTypesLoaded = vm.goalTypesLoadedDefer.promise;
            vm.rootGoalsLoadedDefer = $q.defer();
            vm.rootGoalsLoaded = vm.rootGoalsLoadedDefer.promise;

            vm.EditMode = false;
            vm.FirstTimeCreate = false;
            vm.Save = Save;
            vm.LockGoal = LockGoal;
            vm.Init = Init;
            vm.ShowDeactivate = ShowDeactivate;
            vm.Back = Back;
            vm.IsExpired = IsExpired;
            vm.CompleteTask = CompleteTask;
            vm.IncreaseNewProgress = IncreaseNewProgress;
            vm.DecreaseNewProgress = DecreaseNewProgress;   
            vm.FixSortingToDoList = FixSortingToDoList;         
            vm.GoToActivity = GoToActivity;
            vm.GoToTask = GoToTask;
            vm.GetGoalTypes = GetGoalTypes;   
            vm.GetRootGoals = GetRootGoals;
            vm.GetGoal = GetGoal;
            vm.SetProgressStep = SetProgressStep;
            vm.CreateChildGoalSuggestion = CreateChildGoalSuggestion;
            vm.RemoveChildGoalSuggestion = RemoveChildGoalSuggestion;    
            vm.SelectImage = SelectImage;
            vm.SetEditMode = SetEditMode;
            vm.CancelEdit = CancelEdit;
            
            vm.lblFunction = lblFunction;

            function SelectImage() {
                bizMediabankService.ShowMediabankDialog(vm.Image, null, vm.UploadSettings).then(ShowMediabankDialogCallback);

                function ShowMediabankDialogCallback(file) {                    
                    if (!file)
                        return;
                    vm.Image = file;
                }
            }            

            function lblFunction(val, max) {
                return Math.round(val) + vm.goal.GoalType.Suffix;
            }

            function RemoveChildGoalSuggestion(index) {
                vm.ChildGoalSuggestions.splice(index, 1);
            }

            function CreateChildGoalSuggestion(split) {
                var suggestions = [];

                var monthsPerSplit = 12 / split;                
                var goalValueReminder = vm.goal.GoalValue % split;                

                for (var i = 0; i < split; i++) {
                    var periodStart = moment(vm.SelectedYear.StartDate).startOf('month').add((i * monthsPerSplit), 'M');
                    var periodEnd = moment(periodStart).add(monthsPerSplit - 1, 'M').endOf('month');
                    var textSuffix = (split == 4 ? 'Q' : split === 3 ? 'T' : '') + (i + 1) + '';
                    var goalValue = Math.floor(vm.goal.GoalValue / split);
                    var endList = [];
                    for (var j = 0; j < monthsPerSplit; j++) {
                        var month = moment(periodEnd).add(-j, 'M');
                        endList.push({
                            Name: moment(month).format('DD MMMM'),
                            Date: month
                        });
                    }
                    suggestions.push({
                        Text: vm.goal.Text + ' ' + textSuffix,
                        DateFromLocal: moment(periodStart).format('YYYY-MM-DD'),
                        SelectedToDate: endList[0],
                        GoalValue: goalValue,
                        EndList: endList
                    });
                }

                console.log(suggestions);

                for (var i = 0; i < suggestions.length && goalValueReminder > 0; i++) {
                    suggestions[i].GoalValue++;
                    goalValueReminder--;
                }

                vm.ChildGoalSuggestions = suggestions;
            }            

            function GoToActivity(id) {
                if (id > 0) {
                    $state.go("base.modules.goals.activity", { id: id });
                }
            }

            function GoToTask(id) {
                if (id > 0) {
                    $state.go("base.modules.goals.onetask", { id: id });
                }
            }

            function SetProgressStep() {
                vm.NewProgressSteps = vm.DefaultNewProgressSteps;
                if (vm.SelectedType.SystemName !== 'PERCENT') {
                    if (vm.goal.GoalValue < 100) {
                        vm.NewProgressSteps = 1;
                    } else if (vm.goal.GoalValue > 1000) {
                        vm.NewProgressSteps = vm.DefaultNewProgressSteps * 100;
                    }
                } 
            }

            function IncreaseNewProgress() {
                if (vm.Date > vm.SelectedPeriod.StartDate) {
                    vm.EditMode = true;
                    vm.SetProgressStep();
                    var newValue = vm.NewProgress + 1;
                    while (newValue % vm.NewProgressSteps != 0) {
                        newValue++;
                    }
                    vm.NewProgress = newValue;   
                    
                    vm.Dirty = true;
                }
            }

            function DecreaseNewProgress() {
                if (vm.Date > vm.SelectedPeriod.StartDate) {
                    vm.EditMode = true;
                    vm.SetProgressStep();
                    var newValue = vm.NewProgress - 1;
                    while (newValue % vm.NewProgressSteps != 0) {
                        newValue--;
                    }
                    vm.NewProgress = newValue;

                    vm.Dirty = true;
                }                
            }            

            function CompleteTask(task, act) {
                engagementGoalsService.CompleteTask(task).then(CompleteToDoCallback);

                function CompleteToDoCallback(response) {
                    var index = act.ToDoList.indexOf(task);
                    act.ToDoList.splice(index, 1);
                }
            }

            function IsExpired(task) {
                return !task.IsCompleted && moment(task.DateLocal) < BizPartCoreHelpers.getDateNow();
            }

            function FixSortingToDoList(toDoList) {
                for(var i = 0; i < toDoList.length; i++) {
                    var item = toDoList[i];

                    if(vm.IsExpired(item)) {
                        item.Status = 10;
                    }
                    else if(!item.IsCompleted) {
                        item.Status = 20;
                    }
                    else if(item.IsCompleted) {
                        item.Status = 30;
                    }
                }
            }

            function Back() {
                window.history.back();
            }

            function ShowDeactivate() {
                var parentEl = angular.element(document.querySelector('#goal-progress'));
                $mdDialog.show({
                    parent: parentEl,
                    targetEvent: parentEl,
                    templateUrl: siteRootPath + 'FrontEnd/Modules/EngagementGoals/Views/deactivateGoalPopup.html',
                    controller: ShowDeactivateController,
                    controllerAs: "vm",
                    bindToController: true,
                    clickOutsideToClose: true,
                    locals: {
                        goal: vm.goal,
                        deleteMode: vm.deleteMode
                    }
                }).then(ShowDeactivateCallback, function (response) { });

                function ShowDeactivateCallback() {
                    if (vm.deleteMode) {
                        $state.go('base.modules.goals.engagementgoals');
                    } else {
                        engagementGoalsService.GetGoal(vm.goal.Id).then(function (response) {
                            vm.goal = BizPartCoreHelpers.getResponseValue(response);
                        });
                    }
                }

                ShowDeactivateController.$inject = ["$mdDialog"];

                function ShowDeactivateController($mdDialog) {
                    var vm = this;

                    vm.Close = Close;

                    function Close() {
                        $mdDialog.hide();
                    }
                }
            }

            function GetGoalTypes() {
                engagementGoalsService.GetGoalTypes().then(GetGoalTypesCallback);

                function GetGoalTypesCallback(response) {
                    vm.GoalTypes = BizPartCoreHelpers.getResponseValue(response, []);
                    vm.goalTypesLoadedDefer.resolve('');                    
                }
            }

            function GetRootGoals() {
                engagementGoalsService.GetGoals().then(GetGoalsCallback);

                function GetGoalsCallback(response) {
                    var goals = BizPartCoreHelpers.getResponseValue(response, []);                    
                    vm.RootGoals = $filter('filter')(goals, { ParentGoalId: -1 });
                    vm.rootGoalsLoadedDefer.resolve('');
                }
            }

            function SetEditMode() {
                vm.PreEditGoal = angular.copy(vm.goal);
                vm.PreEditImage = angular.copy(vm.Image);
                vm.EditMode = true;
            }

            function CancelEdit() {
                vm.EditMode = false;
                vm.goal = vm.PreEditGoal;
                vm.Image = vm.PreEditImage;
                vm.NewProgress = vm.goal.ProgressSum;
            }

            function Save() {         

                if (vm.MyForm && !bizValidationService.FormValid(vm.MyForm))
                    return;                        
                
                vm.goal.ImageMediabankId = vm.Image ? vm.Image.Id : -1;
                vm.goal.GoalTypeId = vm.SelectedType.Id;
                vm.goal.ParentGoalId = vm.SelectedRootGoal ? vm.SelectedRootGoal.Id : -1;

                var saveData = {};
                if (vm.goal.Id <= 0 || !vm.goal.IsLocked) {
                    saveData.Goal = vm.goal;
                }

                if (vm.ChildGoalSuggestions) {
                    for (var i = 0; i < vm.ChildGoalSuggestions.length; i++) {
                        vm.ChildGoalSuggestions[i].GoalTypeId = vm.goal.GoalTypeId;
                        vm.ChildGoalSuggestions[i].IsNegative = vm.goal.IsNegative;
                        vm.ChildGoalSuggestions[i].DateToLocal = vm.ChildGoalSuggestions[i].SelectedToDate.Date;
                    }

                    saveData.ChildGoals = vm.ChildGoalSuggestions;
                }

                if (vm.NewProgress) {
                    var change = vm.NewProgress - vm.goal.ProgressSum;
                    var progressDate = vm.NewProgressDate;
                    if (moment(progressDate).isSame(new Date(), "day")) {
                        progressDate = moment();
                    }
                    if (change != 0) {
                        saveData.Progress = {
                            Value: change,
                            DateLocal: progressDate,
                            LinkedObjectId: vm.goal.Id
                        };
                    }
                }

                if (vm.NewComment) {
                    saveData.Comment = {
                        Comment: vm.NewComment,
                        ObjectId: vm.goal.Id
                    };
                }  

                if (!saveData.Goal && !saveData.Progress && !saveData.Comment) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Inget ändrat')
                            .position('bottom right')
                    );
                } else {
                    //We need to trim spaces to make it a valit int.
                    if (saveData.goal && typeof saveData.Goal.GoalValue !== "number")
                        saveData.Goal.GoalValue = ~~saveData.Goal.GoalValue.replace(/\s/g, '');

                    // Added support for min/max values in bizValidation
                    //if (saveData.goal && saveData.Goal.GoalValue <= 0) {
                    //    $mdToast.show(
                    //        $mdToast.simple()
                    //            .textContent('Målets tal måste vara större än 0')
                    //            .position('bottom right')
                    //    );
                    //    return;
                    //}
                    
                    if (vm.isRoot && vm.goal.Id > 0 && ((vm.OriginalType && vm.OriginalType !== vm.goal.GoalTypeId)
                        || (vm.OriginalIsNegative !== undefined && vm.OriginalIsNegative !== vm.goal.IsNegative))) {

                        var confirm = $mdDialog.confirm()
                            .title('Ändring')
                            .textContent('Du har ändrat typ och/eller negativ-status. Samtliga kvartalsmål kommer också att uppdateras med den nya typen och/eller negativ-status.')
                            .ok('Ok')
                            .cancel('Avbryt');

                        $mdDialog.show(confirm).then(function () {
                            CreateUpdateGoal(saveData);
                        }, function () {

                        });

                    } else {
                        CreateUpdateGoal(saveData);
                    }

                    function CreateUpdateGoal(saveData) {
                        engagementGoalsService.CreateUpdateGoal(saveData).then(CreateUpdateGoalCallback);

                        function CreateUpdateGoalCallback(response) {
                            //var isCreated = vm.goal.Id <= 0;
                            vm.goal = BizPartCoreHelpers.getResponseValue(response);
                            if (vm.goal.ImageUrl) {
                                vm.Image = {
                                    FileUrl: vm.goal.ImageUrl
                                };                                
                            }
                            vm.NewComment = undefined;
                            vm.OriginalType = vm.goal.GoalTypeId;
                            vm.OriginalIsNegative = vm.goal.IsNegative;
                            if (vm.FirstTimeCreate) {
                                $rootScope.$broadcast('GOALCREATED', vm.goal);
                                vm.goal = {
                                    DateFromLocal: vm.SelectedPeriod.StartDate.format('YYYY-MM-DD'),
                                    DateToLocal: vm.SelectedPeriod.EndDate.format('YYYY-MM-DD'),
                                    IsActive: true,
                                    Text: '',
                                    IsLocked: false,
                                    Id: 0
                                };
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent('Mål skapat')
                                        .position('bottom right')
                                );
                            } else {
                                vm.EditMode = false;
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent('Mål uppdaterat')
                                        .position('bottom right')
                                );
                            }
                        }
                    }                    
                }                
            }

            function LockGoal(ev) {
                var confirm = $mdDialog.confirm()
                    .title('Vill du låsa målet?')
                    .textContent('Du kan inte redigera målet igen efter att det låsts')
                    .ariaLabel('Vill du låsa målet?')
                    .targetEvent(ev)
                    .ok('Lås')
                    .cancel('Avbryt');

                $mdDialog.show(confirm).then(function () {
                    engagementGoalsService.LockGoal(vm.goal.Id).then(LockGoalCallback);    
                }, function () {
                    
                });
               
                function LockGoalCallback(response) {
                    vm.goal.IsLocked = true;
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('The goal is now locked')
                            .position('bottom right')
                    );
                }
            }

            function GenerateEditMonths() {
                var months = moment(vm.goal.DateToLocal).diff(vm.goal.DateFromLocal, 'months') + 1;

                vm.EditMonths = [];

                for(var i = 0; i < months; i++) {
                    var date = moment(vm.goal.DateFromLocal).endOf('month');
                    if(i > 0) {
                        date = moment(vm.goal.DateFromLocal).add(i, 'months').endOf('month');
                    }
                    vm.EditMonths.push({
                        Name: moment(date).format('DD MMMM'),
                        Value: moment(date).format('YYYY-MM-DD HH:mm:ss')
                    });
                }

                vm.SelectedNewMonth = vm.EditMonths[vm.EditMonths.length - 1];

                $rootScope.$watch(function() { return vm.SelectedNewMonth; }, function(newVal, oldVal) {
                    if(!vm.isRoot && newVal) {
                        vm.goal.DateToLocal = newVal.Value;
                    }
                });
            }

            function GetGoal() {
                engagementGoalsService.GetGoal(vm.goalId).then(GetGoalCallback);

                function GetGoalCallback(response) {
                    vm.goal = BizPartCoreHelpers.getResponseValue(response);   
                    
                    GenerateEditMonths();

                    if (vm.goal.ImageUrl) {
                        vm.Image = {
                            FileUrl: vm.goal.ImageUrl
                        };                        
                    }

                    vm.isRoot = vm.goal.ParentGoalId <= 0;

                    vm.OriginalType = vm.goal.GoalTypeId;
                    vm.OriginalIsNegative = vm.goal.IsNegative;

                    $q.when(vm.goalTypesLoaded).then(function () {
                        if (vm.goal.GoalTypeId) {
                            vm.SelectedType = vm.GoalTypes.GetItemByValue('Id', vm.goal.GoalTypeId);
                        }
                    });

                    $q.when(vm.rootGoalsLoaded).then(function () {
                        if (vm.goal.ParentGoalId > 0) {
                            vm.SelectedRootGoal = vm.RootGoals.GetItemByValue('Id', vm.goal.ParentGoalId);
                        }
                    });
                }
            }            

            function Init() {           
                vm.GetGoalTypes();
                vm.GetRootGoals();

                if (vm.goalId) {
                    vm.GetGoal();
                } else {
                    vm.goal = {
                        DateFromLocal: vm.SelectedPeriod.StartDate.format('YYYY-MM-DD'),
                        DateToLocal: vm.SelectedPeriod.EndDate.format('YYYY-MM-DD'),
                        IsActive: true,
                        Text: '',
                        IsLocked: false,
                        Id: 0
                    };
                    vm.EditMode = true;
                    vm.FirstTimeCreate = true;
                }
                
                vm.NewProgressDate = BizPartCoreHelpers.getDateNow().format('YYYY-MM-DD');
            }            

            $scope.$watch("vm.goal.ProgressSum", function () {
                if (vm.goal) {
                    vm.NewProgress = vm.goal.ProgressSum;

                    var percent = vm.goal.ProgressSumInPercent;
                    if (percent > 100) {
                        percent = 100;
                    }
                    vm.data = [Math.round(percent), Math.round(100 - percent)];
                }
            });       

            $scope.$watch("vm.NewProgress", function () {
                if (vm.goal && !vm.EditMode && vm.NewProgress !== vm.goal.ProgressSum) {
                    vm.EditMode = true;
                }
            });      

            $scope.$watch("vm.SelectedYear", function () {
                if (vm.goal && vm.goal.Id <= 0 && !vm.SelectedRootGoal && vm.SelectedYear) {
                    vm.goal.DateFromLocal = vm.SelectedYear.StartDate.format('YYYY-MM-DD');
                    vm.goal.DateToLocal = vm.SelectedYear.EndDate.format('YYYY-MM-DD');
                }
            });    

            $scope.$watch("vm.SelectedRootGoal", function () {
                if (vm.goal && vm.goal.Id <= 0) {
                    if (vm.SelectedRootGoal) {
                        vm.goal.DateFromLocal = vm.SelectedPeriod.StartDate.format('YYYY-MM-DD');
                        vm.goal.DateToLocal = vm.SelectedPeriod.EndDate.format('YYYY-MM-DD');
                        vm.goal.IsNegative = vm.SelectedRootGoal.IsNegative;
                        vm.SelectedType = vm.SelectedRootGoal.GoalType;
                    } else {
                        vm.goal.DateFromLocal = vm.SelectedYear.StartDate.format('YYYY-MM-DD');
                        vm.goal.DateToLocal = vm.SelectedYear.EndDate.format('YYYY-MM-DD');
                    }                    
                }
            });    

            vm.SelectedRootGoal

            vm.$onInit = vm.Init;
        }

        return directive;
    }

}());